import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getVolumeAnalysis } from '@/src/services/stockDetails';
import { NoData } from '../../../../components/NoData';
import { useSelector } from 'react-redux';
import { selectStockDetails } from '@/src/store/reducers/stocks/stockDetailsSlice';
import { VOLUME_ANALYSIS_LABEL } from '@/src/common/enum';
import { StockVolumeBarChart } from '../../components/StockVolumeBarChart';
import ShimmerLoader from '@/src/components/SkeletonLoader';

type Payload = {
  name: string;
  label: string;
  value: number;
  fill: string;
  date: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ChartContainer = styled.div`
  width: 100%;
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/unused-import, sonarjs/no-unused-vars, sonarjs/no-dead-store, @typescript-eslint/no-explicit-any
const PieChartContainer = styled.div`
  width: 100%;
  @media screen and (max-width: 900px) {
    width: 100%;
    border-right: none;
  }
`;

const ShareHoldings = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border: 1px solid #c6ccff;
  border-radius: 0.8em;
  margin-bottom: 1rem;
  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column;
  }
`;

const Head = styled.h2`
  padding: 16px 0;
  font-family: 'neuePowerTrial-Medium';
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #001317;
  @media screen and (max-width: 900px) {
    font-size: 16px;
    font-weight: 500;
    line-height: 19.2px;
  }
`;

// TODO: Replace `any` with specific type
/* eslint-disable sonarjs/cyclomatic-complexity */
// eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/unused-import, sonarjs/no-unused-vars, sonarjs/no-dead-store, @typescript-eslint/no-explicit-any
export const Overview: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/unused-import, sonarjs/no-unused-vars, sonarjs/no-dead-store, @typescript-eslint/no-explicit-any
  const [overviewData, setOverviewData] = useState<any>(null);
  const [isLoading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/unused-import, sonarjs/no-unused-vars, sonarjs/no-dead-store, @typescript-eslint/no-explicit-any
  const [activeData, setActiveData] = useState<Payload[]>([
    {
      name: 'deliveryvolume',
      label: 'Delivery Volume',
      value: 0,
      fill: '#00b9ae',
      date: '',
    },
    {
      name: 'deliveryvolume',
      label: 'Delivery Volume',
      value: 0,
      fill: '#037171',
      date: '',
    },
  ]);
  const {
    data: { cocode, exchange },
  } = useSelector(selectStockDetails);

  const companyName = document
    .getElementById('csr-stock-details-page')
    ?.getAttribute('data-companyName');

  useEffect(() => {
    if (cocode && exchange) {
      setLoading(true);
      setError(null);

      getVolumeAnalysis(cocode, exchange.toString())
        .then((response) => {
          const formattedData = {
            [VOLUME_ANALYSIS_LABEL.TODAY]: {
              deliveryVolume: response.data[0].DelVol_EOD,
              totalVolume: response.data[0].TolVolCurr,
            },
            [VOLUME_ANALYSIS_LABEL.YESTERDAY]: {
              deliveryVolume: response.data[0].DelVolPrev,
              totalVolume: response.data[0].TotVolPrev,
            },
            [VOLUME_ANALYSIS_LABEL.D5AVG]: {
              deliveryVolume: response.data[0].DelVol5DaysAvg,
              totalVolume: response.data[0].TotVol5DaysAvg,
            },
            [VOLUME_ANALYSIS_LABEL.D30AVG]: {
              deliveryVolume: response.data[0].DelVol30DaysAvg,
              totalVolume: response.data[0].TotVol30DaysAvg,
            },
          };
          setOverviewData(formattedData);
        })
        .catch(() => {
          setError('Failed to load stock overview data.');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [cocode, exchange]);

  if (isLoading) {
    return <ShimmerLoader />;
  }

  if (error) {
    return (
      <>
        <Head>{companyName} Volume Analysis</Head>
        <NoData />
      </>
    );
  }

  if (!overviewData) {
    return (
      <>
        <Head>{companyName} Volume Analysis</Head>
        <NoData />
      </>
    );
  }

  const ShareHoldingPattern = overviewData;

  return (
    <div>
      <Head>{companyName} Volume Analysis</Head>
      <ShareHoldings>
        <ChartContainer>
          {ShareHoldingPattern ? (
            <StockVolumeBarChart
              activeData={activeData || null}
              shareHoldingData={ShareHoldingPattern}
            />
          ) : (
            '-'
          )}
        </ChartContainer>
      </ShareHoldings>
    </div>
  );
};
